import React, { Component } from 'react'
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import axios from 'axios';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

let cancelToken;

class Workshops extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionDescription: false,
            desc_como_se_entero: '',
            succesMessage: false,
            errorMessage: false,
            btnSummit: true
        };
    }
    // ES LO PRIMERO QUE SE EJECUTA AL CARGAR LA PAGINA
    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        window.fbq('track', 'AddPaymentInfo');
    }

    // Crear objeto con los datos para crear rsgistro por medio del webservice 
    handleSubmit = (event) => {
        event.preventDefault();
        let infoSuscriptor = this.state;        
        infoSuscriptor.token_id = this.props.getTokenId();
        this.setState({btnSummit: false});
        this.suscriptionWebinar(infoSuscriptor);
    }

    // EJECUTAR WEB SERVICE DE PAGO
    suscriptionWebinar = (params) => {
        this.props.post(
            "/suscription",
            params,
            (response) => this.succesSuscription(response),
            (error, error_type, conekta_msj, msg) => this.errorSuscription(error, error_type, conekta_msj, msg),
            cancelToken
        );
    }

    succesSuscription = (info) => {
        this.setState({succesMessage: true});
    }

    errorSuscription = (info) => {
        this.setState({errorMessage: true});
    }

    // SE CREA ARREGLO CON VALORES DEL FORMULARIO PARA ENVIARLOS AL WEB SERVICE
    handleInputChange = (event) => {
        let name = event.target.name;
         this.setState({
             [name]: event.target.value
         });
    }

    // Validacion para mostrar campo de referencia en caso de que aplique
    handleChangeEvent = (event) => {
        this.handleInputChange(event);
        let refencia = {option: event.target.value};
        if (refencia.option == 6) {
            this.setState({sectionDescription: true});
        }else{
            this.setState({sectionDescription: false});
        }
    }

    // Body
    render() {
        return( 
            <div>
                {this.renderNavbar()}
                <div className="panel panel-default">
                    <div className="page-header"></div>
                    <div className="panel-body container-fluid jumbotron" style={{background:" #f0f0f0ad"}}>
                        <div className="row">
                            <h4 className="page-header text-primary col-xs-12" style={title}>
                                <strong>SUSCRIPCIÓN A WEBINARS IOS OFFICES</strong>
                            </h4>
                            <form method="post" onSubmit={this.handleSubmit} >
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">NOMBRE<i style={required}>*</i></label>
                                        <input className="form-control" id="name" name="nombre" placeholder="NOMBRE" type="text" required onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">APELLIDOS<i style={required}>*</i></label>
                                        <input className="form-control" id="apellido" name="apellidos" placeholder="APELLIDOS" type="text" required onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">CORREO<i style={required}>*</i></label>
                                        <input className="form-control" id="email" name="correo" placeholder="example@iosoffices.com" type="email" required onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="event">¿COMO SE ENTERO DEL EVENTO?<i style={required}>*</i></label>
                                        <select className="form-control" id="evento" name="como_se_entero"  value={this.state.value} required onChange={this.handleChangeEvent}>
                                            <option value="">Seleccione una opción</option>
                                            <option value="1">Soy socio IOS</option>
                                            <option value="2">Revista</option>
                                            <option value="3">Web Digital</option>
                                            <option value="4">Referencia</option>
                                            <option value="5">Redes Sociales</option>
                                            <option value="6">Otro</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">CIUDAD<i style={required}>*</i></label>
                                        <input className="form-control" id="ciudad" name="ciudad" placeholder="CIUDAD" type="text" required onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">EMPRESA</label>
                                        <input className="form-control" id="empresa" name="empresa" placeholder="EMPRESA" type="text" onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="company">TIPO EMPRESA</label>
                                        <select className="form-control" id="tipo_empresa" name="tipo_empresa" onChange={this.handleInputChange}>
                                            <option value="">Seleccione una opción</option>
                                            <option value="1">1 - Persona</option>
                                            <option value="2">2 - 15 Personas</option>
                                            <option value="3">15 - 50 Personas</option>
                                            <option value="4">50 - 100 Personas</option>
                                            <option value="5">100 - 500 Personas</option>
                                            <option value="6">500 o más</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">¿WEBINAR AL QUE DESEA SUSCRIBIRSE?<i style={required}>*</i></label>
                                        <input className="form-control" id="webinar" name="webinar" placeholder="WEBINAR" type="text" required onChange={this.handleInputChange}/>
                                    </div>
                                </div>
                                <div className="panel-body col-xs-12">
                                    {this.state.sectionDescription ? this.inputDescription() : ""}
                                </div>
                                <div className="row">
                                    {this.state.btnSummit ? this.buttonSumit() : ""}
                                </div>
                                <div className="col-xs-12">
                                    {this.state.succesMessage ? this.suscriptionSucces() : ""}
                                    {this.state.errorMessage ? this.suscriptionError() : ""}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div >
                    {this.renderFooter()}
                </div>
            </div>
        );
    }

    // SELECT REDES SOCIALES
    inputDescription = () => {
        return (
            <div className="form-group">
                <label htmlFor="name">ESPECIFIQUE EL MEDIO POR EL CUAL SE ENTERÓ DE LOS WEBINARS<i style={required}>*</i></label>
                <input className="form-control" id="como_se_entero" name="desc_como_se_entero" placeholder="PUBLICIDAD" type="text" required onChange={this.handleInputChange}/>
            </div>
        );
    }

    // BTN SUMMIT
    buttonSumit = () => {
        return (
            <div className="panel-body col-xs-12" style={{textAlign: "center"}}>  
                <button className="btn btn-primary" type="submit"> SUSCRIBIRME A WEBINAR </button>
            </div> 
        );
    }

    // Mensaje de suscripcion exitosa
    suscriptionSucces = () => {
        return (
            <div className="form-group" style={succesMessage}>
                <center>
                    <table>
                        <tbody>
                            <tr style={{color: 'white',fontSize: '17px',padding:'10px',textAlign:'center'}}><td><i className="fa fa-check-square" aria-hidden="true"></i> <b>{this.state.nombre}</b> tu suscripción se realizo de forma exitosa</td></tr>
                            <tr style={{color: 'white',fontSize: '12px',padding:'10px',textAlign:'center'}}><td>(Los detalles se te enviaran por medio de un correo electrónico)</td></tr>
                        </tbody>
                    </table>
                </center>
            </div>
        );
    }

    // Mensaje de error al crear suscripcion
    suscriptionError = () => {
        return (
            <div className="form-group" style={errorMessage}>
                <center><p style={{color: 'white',fontSize: '17px',padding:'10px'}}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Error al procesar la solicitud</p></center>
            </div>
        );
    }

    //Section footer 
    renderFooter = () => {
        return(
            <Footer />
        );
    }

    // Section header
    renderNavbar = () => {
        return(
            <Navbar
            handleLanguageChange={this.props.handleLanguageChange}
            lang={this.props.lang} />
        );
    }
}

export default compose(withRouter)(Workshops);

const title = {
    background: '#00bcd4',
    color: '#fff',
    fontSize: 'LARGE',
    fontWeight: '700',
    padding: '16px',
    paddingRight: '56px',
    textAlign: 'center',
    marginTop: 'auto',
    top: '-15px',
};

const required = {
    color: "#bf3c3c", 
    fontSize: "larger"
}

const footer = {
    position: 'fixed',
    bottom: 0,
    zIndex: 999999,
    width: '-moz-available'
}

const succesMessage = {
    background: "#22c40a7d",  
    borderRadius:"5px", 
    fontStyle:"italic",
    padding: '10px'
}

const errorMessage = {
    background: "#db920b",  
    borderRadius:"5px", 
    fontStyle:"italic"
}


// WEBPACK FOOTER //
// ./src/guest/webinars/webinars.js